module.exports = __webpack_public_path__ + "img/eye.1fabdc25.svg";